window.events = new Vue();

window.toggleNav = function () {
    window.events.$emit('togglenav');

};